import React from 'react';
import { gql } from '@apollo/client';
import IdInput from 'components/Filter/IdInput';
import { BooleanField, Datagrid, BooleanInput, DateInput } from 'react-admin';
import List from 'components/List';
import StateInput from 'components/StateInput';
import LinkField from 'components/LinkField';
import DateTimeField from 'components/DateTimeField';
import LocationTypeInput from 'components/LocationTypeInput';
import PositionInput from 'components/PositionInput';
import { getSettingsQuery } from '../utils/getSettingsQuery';

const StateLocationTypePositionRateSettingListFilters = [
  <IdInput />,
  <StateInput label="State" source="state_id" alwaysOn resettable />,
  <LocationTypeInput label="Location Type" source="location_type_id" alwaysOn resettable />,
  <PositionInput emptyText="All" alwaysOn />,
  <BooleanInput alwaysOn source="active" />,
  <DateInput alwaysOn label="Updated after" source="search.updated_at_from" />,
];

const StateLocationTypePositionRateSettingList = () => {
  return (
    <List filters={StateLocationTypePositionRateSettingListFilters} exporter={false}>
      <Datagrid bulkActionButtons={false}>
        <LinkField label="ID" source="id" />
        <LinkField label="State" source="state.name" sortBy="state_name" />
        <LinkField label="Location Type" source="location_type.label" sortBy="location_type_name" />
        <LinkField label="Position" source="position.display_name" sortBy="position_name" />
        <LinkField label="Specialty" source="specialty.label" sortBy="specialty_name" />
        <BooleanField source="active" />
        <DateTimeField
          format="MM/dd/yyyy HH:mm"
          source="updated_at"
          timeZone="America/Los_Angeles"
        />
      </Datagrid>
    </List>
  );
};

StateLocationTypePositionRateSettingList.query = gql`
  query stateLocationTypePositionRateSettings(
    $input: StateLocationTypePositionRateSettingQueryInput
  ) {
    _stateLocationTypePositionRateSettingsMeta(input: $input) {
      count
    }
    stateLocationTypePositionRateSettings(input: $input) {
      id
      active
      state {
        id
        name
      }
      location_type {
        id
        label
      }
      location_type_id
      position_id
      position {
        id
        display_name
      }
      state_position_rate_setting_id
      state_location_type_position_rate_setting_id
      state_position_rate_setting_active
      state_location_type_position_rate_setting_active
      ${getSettingsQuery(true)}
      ${getSettingsQuery(true, 'active_non_markup_settings')}
      blended_settings_charge_rate
      non_blended_settings_charge_rate
      specialty_id
      specialty {
        id
        label
      }
      state_id
      updated_at
      with_markup_settings {
        ten99 {
          charge_rate_cents
        }
        w2 {
          local {
            charge_rate_cents
          }
          travel {
            charge_rate_cents
          }
        }
      }
    }
  }
`;

export default StateLocationTypePositionRateSettingList;
